import { render } from "./EditContact.vue?vue&type=template&id=0b6d00b5"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"

import "./EditContact.vue?vue&type=style&index=0&id=0b6d00b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__